import {Component, Object3D} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';
import {StatNames} from '../enums/StatNames.js';
import {Statistics} from './statistics.js';

export class IncrementStatOnSpawn extends Component {
    static TypeName = 'increment-stat-on-spawn';

    @property.enum(Object.keys(StatNames).filter((e) => isNaN(Number(e))))
    stat: StatNames;

    @property.int(1)
    incrementAmount = 1;

    start() {
        Statistics.instance.recordAdditive(this.stat, this.incrementAmount);
        this.destroy();
    }
}
